<template>
  <div class="box">
    <div class="main">
      <div class="information">
        当前就诊人：*成成
        <button>切换</button>
      </div>
      <van-cell title="真实姓名" value="*成" />
      <van-cell title="身份证号" value="211111100101010011" />
      <van-cell title="手机号码" value="12312341234" />
      <van-cell title="登记号" value="123123" />
      <van-cell title="常用卡" value="123412341234" />
      <div class="qrcode">
        <img src="../../assets/qrcode.png" />
      </div>
    </div>
    <div class="footer">
      <van-button type="info" :round="true" size="small">接触绑定</van-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'seeadoctor',
  data() {
    return {}
  },
  created() {},
  mounted() {},
  methods: {}
}
</script>
<style scoped>
.main {
  width: 100vw;
  height: 100vh;
  background-color: rgb(242, 248, 253);
}
.information {
  color: #ffffff;
  background-color: rgb(8, 112, 253);
  padding: 7px 10px;
  font-size: 18px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.information button {
  background-color: #ffffff;
  font-size: 18px;
  color: rgb(79, 188, 251);
  border: 1px solid rgb(8, 112, 253);
  border-radius: 20px;
}
.qrcode {
  margin: 50px auto;
  width: 190px;
  height: 190px;
}
.qrcode img {
  width: 100%;
  height: 100%;
}
.footer {
  width: 100vw;
  position: fixed;
  bottom: 0px;
  left: 0px;
  right: 0px;
  display: flex;
  background-color: #ffffff;
}
.footer button {
  width: calc(100% - 40px);
  margin: 10px 20px 10px 20px;
}
</style>
